<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <h1 class="title">Customer Output ChangeLog</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div *ngFor="let version of versions">
                <table class="table-version-number">
                    <tr class="row-version-number">
                        <td>
                            <h3 class="version-number">v. {{ version.version }}</h3>
                        </td>
                    </tr>
                    <tr *ngFor="let build of version.builds" class="row-build-number">
                        <td>
                            <table class="table-build-number">
                                <tr>
                                    <td colspan="3" class="title-build-number">
                                        <span class="build-number">Build {{ build.build }}</span>
                                        <span class="build-date">&nbsp;({{ build.date }})</span>
                                    </td>
                                </tr>
                                <tr *ngFor="let commit of build.commits" class="row-commit">
                                    <td>
                                        <div class="info-type type-{{ commit.type | lowercase }}">{{ commit.type }}</div>
                                    </td>
                                    <td>
                                        <div class="info-issue" *ngIf="commit.issue">
                                            <a href="https://gitlab.com/innovazione/customer_output/-/issues/{{ commit.issue.replace('#', '') }}" target="_blank">
                                                <img src="assets/images/gitlab.png" alt="GitLab" class="img-gitlab" />
                                            </a>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="info-text">{{ commit.text }}</div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </div>            
        </div>
    </div>
</div>

